import API from '../apiCreate'
import type {
  NotificationDeliveryTargetDiscoverRequest,
  NotificationDeliveryTargetDiscoverResponse,
  NotificationDeliveryTargetIndexResponse,
  NotificationDeliveryTargetSaveRequest,
} from './notification-delivery-target.types'

export const notificationDeliveryTargetApi = {
  /** Справочник групп. `notification_id` опционален — для prefill selected. */
  getIndex: (notificationId?: number | null) => {
    const qs =
      notificationId && notificationId > 0
        ? `?notification_id=${notificationId}`
        : ''
    return API.get<NotificationDeliveryTargetIndexResponse>(
      `notification-delivery-target/index${qs}`,
    )
  },

  save: (data: NotificationDeliveryTargetSaveRequest) =>
    API.post<NotificationDeliveryTargetIndexResponse>(
      'notification-delivery-target/save',
      data,
    ),

  discover: (data: NotificationDeliveryTargetDiscoverRequest) =>
    API.post<NotificationDeliveryTargetDiscoverResponse>(
      'notification-delivery-target/discover',
      data,
    ),
}
